import { useConfirm } from '../../../components/confirm';
import { useNotify } from '../../../components/notifications';
import { useInboxStore } from './inboxStore';

/** The ONE Acknowledge action (pop-up card + detail dialog): shared confirm → API (audited
 *  server-side, idempotent) → shared success message. Resolves true when acknowledged. */
export function useAcknowledgeAlert(): (id: string) => Promise<boolean> {
  const { confirm } = useConfirm();
  const notify = useNotify();
  return async (id: string) => {
    const ok = await confirm({ title: 'Acknowledge', message: 'Acknowledge this alert? Your name and the time are recorded.' });
    if (!ok) return false;
    try {
      await useInboxStore.getState().acknowledge(id);
      notify.success('Acknowledged.');
      return true;
    } catch {
      notify.error('Could not acknowledge the alert. Please retry.');
      return false;
    }
  };
}
